realmCommerceApp.factory("gaProductService", GaProductService);

/*@ngInject*/
function GaProductService(platformGAEcommerceConfig, configMapperService) {
    var service = {
        getProductDetails: getProductDetails,
    }
    return service;

    function getProductDetails(trackData) {
        let config = platformGAEcommerceConfig.getConfigurationKey('productDetails');
        const productDetails = configMapperService.mapData(config, trackData);
        return productDetails;
    }
}


// WEBPACK FOOTER //
// ./static/js/app/services/ga.product.service.js